import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
  ListItemIcon,
  SvgIcon,
} from '@mui/material';
import {
  AdminIcon,
  ArchiveIcon,
  RequestIcon,
  StarIcon,
  QuoteIcon,
} from 'Components/Icons';
import Grid from '@mui/material/Grid2';
import { UserType } from 'shared/types/User.types';

const classes = {
  drawer: {
    width: 250,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: 250,
      boxSizing: 'border-box',
      boxShadow: '10px 0px 10px #0000001A',
    },
  },
};

const LHS: React.FC<{ user: UserType }> = ({ user }): React.ReactElement => {
  const location = useLocation();

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={classes.drawer}
      PaperProps={{
        style: {
          backgroundColor: '#2D2926',
          borderRight: 0,
        },
      }}>
      <Stack
        justifyContent="space-between"
        sx={{
          height: '100%',
        }}>
        <List>
          <ListItem
            sx={{ mb: '8px', justifyContent: 'center', padding: '12px 18px', gap: '24px' }}
            component={Link}
            to="/new-brief">
            <img style={{ width: '200px' }}
              alt="Women's Football logo"
              src="/images/WSLC_CORP_BW_HOR_RGB.svg" />
          </ListItem>
          <ListItem sx={{ borderBottom: '1px solid rgba(255, 255, 255, 0.2)', padding: '16px' }}>
            <Typography >BRIEFING PLATFORM</Typography>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/live-projects"
              selected={location.pathname.startsWith('/live-projects')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <StarIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="Live projects" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/quote-requests"
              selected={location.pathname.startsWith('/quote-requests')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <QuoteIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="Quote Requests" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/new-brief"
              selected={location.pathname.startsWith('/new-brief')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <RequestIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="New Brief" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/archive"
              selected={location.pathname.startsWith('/archive')}
              alignItems="center">
              <ListItemIcon>
                <SvgIcon>
                  <ArchiveIcon />
                </SvgIcon>
              </ListItemIcon>
              <ListItemText primary="Archive" />
            </ListItemButton>
          </ListItem>

          {user?.is_super_admin && (
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/admin"
                selected={location.pathname.startsWith('/admin')}
                alignItems="center">
                <ListItemIcon>
                  <SvgIcon>
                    <AdminIcon />
                  </SvgIcon>
                </ListItemIcon>
                <ListItemText primary="Admin" />
              </ListItemButton>
            </ListItem>
          )}
        </List>

        <List>
          <Grid container justifyContent="center">
            <Grid>
              <Typography
                sx={{
                  color: '#F1F1F1',
                  fontSize: '12px',
                }}>
                Powered by
              </Typography>
            </Grid>
            <Grid>
              <img
                style={{ height: '18px', marginLeft: '10px' }}
                alt="Bylder Logo"
                src="/images/logo/bylder-logo.svg"
              />
            </Grid>
          </Grid>
        </List>
      </Stack>
    </Drawer>
  );
};

export default LHS;
